import { MAX_REGENERATIONS, MAX_REVISIONS } from './reviewLimits';

interface ReviewBudgetProps {
  /** `request.attempt` — position in the lineage, starting at 1. */
  attempt: number;
  /** `request.revisions` — revisions and redesigns spent on this lineage. */
  revisions: number;
}

/**
 * What this request has left, beside the buttons that spend it.
 *
 * Both numbers come off the request row rather than from anything this session
 * counted, so a reload, a second tab and a run the worker advanced all read the
 * same. It is deliberately permanent rather than a warning that appears near
 * the end: a reviewer deciding between a revision and a regeneration is making
 * a spending decision, and the figures belong in front of them while they make
 * it, not in the 409 afterwards.
 */
export function ReviewBudget({ attempt, revisions }: ReviewBudgetProps) {
  // The row *is* the count: attempt 1 is the first draft, and the server
  // refuses another once attempt reaches the cap. So the honest line is
  // attempts, not regenerations — a capped lineage reads 3 of 3.
  const attemptsUsed = Math.min(Math.max(attempt, 1), MAX_REGENERATIONS);
  const revisionsUsed = Math.min(revisions, MAX_REVISIONS);

  return (
    <p className="review-budget">
      Tries: {attemptsUsed} of {MAX_REGENERATIONS} · Revisions: {revisionsUsed} of {MAX_REVISIONS}
    </p>
  );
}
